import { useEffect, useRef, useState } from 'react'
import { Icon } from '@iconify/react'
import styles from './MascotGame.module.css'

export function MascotVoice() {
  const [recording, setRecording] = useState(false)
  const [message, setMessage] = useState('Fale por até 4 segundos. Seu mascote repete!')
  const media = useRef<MediaStream | null>(null)
  const recorder = useRef<MediaRecorder | null>(null)
  const player = useRef<HTMLAudioElement | null>(null)
  const url = useRef<string | null>(null)
  const timer = useRef<number | undefined>(undefined)
  const mounted = useRef(false)
  const requesting = useRef(false)
  useEffect(() => {
    mounted.current = true
    return () => {
      mounted.current = false
      clearTimeout(timer.current)
      if (recorder.current?.state === 'recording') recorder.current.stop()
      media.current?.getTracks().forEach((track) => track.stop())
      player.current?.pause()
      if (url.current) URL.revokeObjectURL(url.current)
    }
  }, [])
  async function talk() {
    if (requesting.current) return
    if (recording) {
      recorder.current?.stop()
      return
    }
    if (!navigator.mediaDevices?.getUserMedia || !window.MediaRecorder) {
      setMessage('O microfone não está disponível neste navegador.')
      return
    }
    requesting.current = true
    setMessage('Abrindo microfone…')
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
      if (!mounted.current) {
        stream.getTracks().forEach((track) => track.stop())
        return
      }
      media.current = stream
      const recordingDevice = new MediaRecorder(stream)
      recorder.current = recordingDevice
      const chunks: BlobPart[] = []
      recordingDevice.ondataavailable = (event) => {
        if (event.data.size) chunks.push(event.data)
      }
      recordingDevice.onstop = () => {
        clearTimeout(timer.current)
        stream.getTracks().forEach((track) => track.stop())
        if (!mounted.current) return
        setRecording(false)
        if (url.current) URL.revokeObjectURL(url.current)
        url.current = URL.createObjectURL(
          new Blob(chunks, { type: recordingDevice.mimeType })
        )
        player.current?.pause()
        const audio = new Audio(url.current)
        player.current = audio
        audio.playbackRate = 1.35
        audio.preservesPitch = false
        setMessage('Olha o que eu aprendi com você!')
        void audio.play().catch(() => {
          if (mounted.current) setMessage('Não consegui repetir agora. Tente novamente.')
        })
      }
      recordingDevice.start()
      setRecording(true)
      setMessage('Estou ouvindo… toque para terminar.')
      timer.current = window.setTimeout(() => {
        if (recordingDevice.state === 'recording') recordingDevice.stop()
      }, 4000)
    } catch {
      if (mounted.current)
        setMessage('Permita o microfone no navegador para conversar com seu mascote.')
      media.current?.getTracks().forEach((track) => track.stop())
    } finally {
      requesting.current = false
    }
  }
  return (
    <div className={styles.voice}>
      <button className={styles.secondaryButton} onClick={() => void talk()}>
        <Icon icon={recording ? 'mdi:stop-circle-outline' : 'mdi:microphone-outline'} />
        {recording ? 'Terminar gravação' : 'Fale comigo'}
      </button>
      <p role="status">{message}</p>
      <small>A voz fica só neste aparelho e não é enviada.</small>
    </div>
  )
}
